import { map, flatten } from "../client/src/fable_modules/fable-library.3.7.17/Option.js";
import { Validation_parseFloat, Validation_nonNegativeFloat } from "./Domain.fs.js";

export const ParseNonNegative = (arg_1) => flatten(map(Validation_nonNegativeFloat, Validation_parseFloat(arg_1)));

